import Reflux from 'reflux-react-16'
import moment from 'moment'
import _ from 'underscore'
import socket from '../socketio/socketio.js'
import ShiftActions from '../actions/ShiftActions.js'
import LoginStore from './LoginStore.js'
import {getStoredDates, storeDates} from '../utils/storedDates.js'

export default class ShiftStore extends Reflux.Store {
    constructor() {
        super()

        const storedDates = getStoredDates('shifts')

        this.state = {
            startDate: storedDates?.startDate || moment().format('YYYY-MM-DD'),
            endDate: storedDates?.endDate || moment().format('YYYY-MM-DD'),
            shiftQueries: [],
            shifts: [],
            selectedShifts: [],
            shiftsLoading: false,
            shiftLimitWarning: false,

            shiftTemplateQueries: [],
            shiftTemplates: [],
            selectedShiftTemplates: [],
            shiftTemplatesLoading: false
        }

        this.listenables = ShiftActions

        ShiftActions.get(true)
        ShiftActions.getTemplates(true)

        socket.on('updateShifts', () => {
            ShiftActions.get(false)
        })

        socket.on('updateShiftTemplates', () => {
            ShiftActions.getTemplates(false)
        })
    }

    onSetDates(startDate, endDate) {
        this.setState({startDate, endDate, selectedShifts: []})
        storeDates('shifts', startDate, endDate)
        ShiftActions.get(true)
    }

    onSetQueries(shiftQueries) {
        this.setState({shiftQueries, selectedShifts: []})
    }

    onSetSelected(selectedShifts) {
        this.setState({selectedShifts})
    }

    onGet(loading) {
        const {startDate, endDate, selectedShifts} = this.state

        this.setState({shiftsLoading: !!loading})

        socket.emit('shifts.get', sessionStorage.token, startDate, endDate, LoginStore.state.selectedBranchIds, (err, shifts) => {
            if (!err) {
                const ids = _.pluck(shifts, '_id')

                this.setState({
                    shifts,
                    selectedShifts: _.filter(selectedShifts, (id) => ids.indexOf(id) > -1),
                    shiftsLoading: false,
                    shiftLimitWarning: shifts.length >= 10000
                })
            }
        })
    }

    onSetTemplateQueries(shiftTemplateQueries) {
        this.setState({shiftTemplateQueries, selectedShiftTemplates: []})
    }

    onSetSelectedTemplates(selectedShiftTemplates) {
        this.setState({selectedShiftTemplates})
    }

    onGetTemplates(loading) {
        this.setState({shiftTemplatesLoading: !!loading})

        socket.emit('shifts.getTemplates', sessionStorage.token, LoginStore.state.selectedBranchIds, (err, shiftTemplates) => {
            console.log(shiftTemplates)

            if (!err) {
                const ids = _.pluck(shiftTemplates, '_id')

                this.setState({
                    shiftTemplates,
                    selectedShiftTemplates: _.filter(this.state.selectedShiftTemplates, (id) => ids.indexOf(id) > -1),
                    shiftTemplatesLoading: false
                })
            }
        })
    }
}
